import React, { useState, useRef, useEffect } from 'react';
import EmojiPicker from 'emoji-picker-react';

// Only one emoji picker open at a time
let closeCurrentEmojiPicker = null;

function EmojiPickerButton({ onSelect, className, title = 'Add emoji' }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const openPicker = () => {
    if (typeof closeCurrentEmojiPicker === 'function') {
      closeCurrentEmojiPicker();
    }
    closeCurrentEmojiPicker = () => setOpen(false);
    setOpen(true);
  };

  const closePicker = () => {
    setOpen(false);
    closeCurrentEmojiPicker = null;
  };

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        closePicker();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleEmojiClick = (emojiData) => {
    const emoji = emojiData.emoji ?? emojiData;
    if (onSelect && typeof onSelect === 'function') {
      onSelect(emoji);
    }
    closePicker();
  };

  return (
    <div ref={containerRef} className="emoji-picker-button-wrapper" style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={openPicker}
        className={className}
        title={title}
        aria-label={title}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '4px 6px',
          fontSize: '1.1rem',
          lineHeight: 1,
        }}
      >
        😀
      </button>
      {open && (
        <div
          className="emoji-picker-popup"
          style={{
            position: 'absolute',
            left: 0,
            top: '100%',
            marginTop: 4,
            zIndex: 10000,
            overflow: 'auto',
            border: '1px solid #e0e0e0',
            borderRadius: 8,
            boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
            background: '#fff',
          }}
        >
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            theme="light"
            width={352}
            height={450}
            searchDisabled={false}
            previewConfig={{ showPreview: false }}
          />
        </div>
      )}
    </div>
  );
}

export default EmojiPickerButton;
